import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Eyebrow from "@/components/Eyebrow";
import SEO from "@/components/SEO";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

const fmtDate = (v) => {
  try {
    return new Date(v).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return "";
  }
};

export default function News() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api.get("/news").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  return (
    <section className="py-24 min-h-[60vh]">
      <SEO title="News & Films · HOFAVIPROC" description="Documentary storytelling and program updates from Mango Town, Brewerville, and across District 17." path="/news" />
      <div className="max-w-[1140px] mx-auto px-6">
        <Eyebrow>HOFAVIPROC · Stories from the ground</Eyebrow>
        <h1 className="text-[clamp(38px,5vw,60px)] mb-4 max-w-[24ch] font-display font-bold">
          News, films, and community dispatches.
        </h1>
        <p className="text-ink/75 max-w-[62ch] mb-12">
          Documentary storytelling and program updates from Mango Town, Brewerville, and across District 17 — produced by HOFA's in-house media team.
        </p>

        {posts === null && (
          <div className="flex items-center gap-3 text-ink/60"><Loader2 className="animate-spin" size={18} /> Loading stories…</div>
        )}

        {posts && posts.length === 0 && (
          <div className="bg-white border border-ink/10 rounded-[14px] p-10 text-center">
            <h3 className="font-display text-xl mb-2">No stories published yet.</h3>
            <p className="text-ink/65">Check back soon — HOFAVIPROC releases new dispatches monthly.</p>
          </div>
        )}

        {posts && posts.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {posts.map((p) => (
              <Link
                key={p.id}
                to={`/news/${p.slug}`}
                data-testid={`news-card-${p.slug}`}
                className="bg-white border border-ink/10 rounded-[14px] overflow-hidden no-underline text-ink flex flex-col hover:-translate-y-1 hover:shadow-xl transition"
              >
                {p.cover_url ? (
                  <div className="aspect-[16/9] overflow-hidden bg-ink/5">
                    <img src={p.cover_url} alt="" className="w-full h-full object-cover" loading="lazy" />
                  </div>
                ) : (
                  <div className="aspect-[16/9] bg-gradient-to-br from-palm to-palm-deep flex items-end p-5">
                    <span className="font-display text-white/90 text-2xl">HOFA</span>
                  </div>
                )}
                <div className="p-6 flex flex-col gap-2 flex-1">
                  <div className="flex items-center gap-2 text-xs text-ink/55">
                    <span className="uppercase tracking-[0.12em] font-bold text-mango-deep">{p.tag || "News"}</span>
                    <span>·</span>
                    <span>{fmtDate(p.created_at)}</span>
                  </div>
                  <h3 className="font-display text-xl">{p.title}</h3>
                  <p className="text-[15px] text-ink/75 flex-1">{p.excerpt}</p>
                  <span className="text-palm font-bold text-sm mt-2">Read story →</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
